import { ManageTandemGroupsComponent } from './manage-tandem-groups.component';
import { connect } from 'react-redux';
import { AppState } from '../../app.state';

export const ManageTandemGroups = connect((sState: AppState) => ({ sState }))(
  //@ts-ignore
  ManageTandemGroupsComponent as any
) as unknown as typeof ManageTandemGroupsComponent;
